export default "__VITE_ASSET__9a9f1951__"